import { useQuery } from '@tanstack/react-query';
import { ApiEndpointEnum } from '@/enums/ApiEndpointEnum';
import useApiFetch from './useApiFetch';
import type { CommerceCountry } from '@/types/commerce/Country';

export function useGetCountries() {
  const { get } = useApiFetch();
  return useQuery<CommerceCountry[]>({
    queryKey: ['countries', 'shipping'],
    queryFn: async ({ signal }) => {
      const res = await get(ApiEndpointEnum.CommerceCountries, undefined, signal);
      // API returns an array of countries: { id, iso, name }
      const data = Array.isArray(res) ? res : (res && (res as any).data ? (res as any).data : []);
      return data as CommerceCountry[];
    },
    staleTime: 60 * 60 * 1000, // 1 hour
  });
}
